import {
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  CardHeader,
  CardTitle,
  Button,
} from "reactstrap";

import { NavLink } from "react-router-dom";
import { useState, React, useEffect, useRef, useContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;

import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { useTranslation } from "react-i18next";
import SelectComponent from "components/Utils/select.js";

const RoomEdit = () => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  let formError = false;

  const [values, setValues] = useState({
    number: "",
    macAddress: "",
    profile: "",
  });

  const [states, setStates] = useState({
    number: "",
    macAddress: "",
    profile: "",
  });

  const [roomId, setRoomId] = useState(
    location.state ? location.state.roomId : "",
  );
  const [siteId, setSiteId] = useState(
    location.state ? location.state.siteId : "",
  );

  const [siteName, setSiteName] = useState("");
  const [profiles, setProfiles] = useState([]);

  const [mode, setMode] = useState(location.state ? location.state.mode : "");
  const [errorMsg, setErrorMsg] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const privileges = useContext(MainContext);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["installations.site.edit"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }
  }, []);

  useEffect(() => {
    if (mode == "edit") {
      fetchEditData();
    }
  }, [mode]);

  const redirectToSiteDetails = () => {
    const location = {
      pathname: "/admin/installations/site/details",
      state: {
        siteId: siteId,
        status: "all",
      },
    };
    history.push(location);
  };

  // Actions to do on submit
  const handleSubmit = (e) => {
    e.preventDefault();

    formError = false;

    // Validate all the field before calling the API
    if (mode == "edit") {
      setStates({
        ...states,
        ["macAddress"]: validateField("macAddress"),
      });
    }

    if (!formError) {
      postData();
    }
  };

  const validateField = (field) => {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (!formError && status.length > 0) {
      formError = true;
    }
    return status;
  };

  const fetchEditData = () => {
    setShowLoading(true);

    fetch("/api/v1/site/room/edit", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token"),
        sessionId: sessionStorage.getItem("sessionId"),
        roomId: roomId,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        if (actualData.status == "200") {
          setValues({
            ...values,
            number: actualData.data.number,
            macAddress: actualData.data.macAddress,
            profile: actualData.data.profile,
          });

          setSiteName(actualData.data.siteName);

          // Prepare Profile List
          const fetchedProfilesRawData = actualData.data.profiles;
          const formattedOptions = fetchedProfilesRawData.map((item) => ({
            value: item,
            label: item,
          }));
          setProfiles(formattedOptions);

          // Set the default profile
          formattedOptions.map((profileOption) => {
            if (profileOption.value === actualData.data.profile) {
              setSelectedProfile(profileOption);
            }
          });
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const postData = () => {
    setShowLoading(true);

    // Prepare Url and Api Method
    let apiUrl = "";
    let apiMethod = "";
    if (mode == "edit") {
      apiUrl = "/api/v1/site/room/edit";
      apiMethod = "PUT";
    }

    // Call the API
    fetch(apiUrl, {
      method: apiMethod,
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token"),
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        roomId: roomId,
        number: values.number,
        macAddress: values.macAddress,
        profile: values.profile,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          setErrorMsg(actualData.error_code);
        } else {
          setErrorMsg([]);

          redirectToSiteDetails();
        }
      })
      .catch((err) => {
        console.log(err.message);
        setShowLoading(false);
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleProfileChange = (option) => {
    setValues({
      ...values,
      ["profile"]: option.value.value,
    });
    setSelectedProfile(option);
  };

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />

        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>

                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/installations/site/list",
                      }}
                    >
                      {t(
                        "sites.breadcrumb.sites.t." +
                          sessionStorage.getItem("bundleType"),
                        "Sites",
                      )}
                    </NavLink>
                    {siteName ? <i>&lt;{siteName}&gt;</i> : ""}
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/installations/site/details",
                        state: {
                          siteId: siteId,
                        },
                      }}
                    >
                      Details
                    </NavLink>
                    {values.number ? <i>&lt;{values.number}&gt;</i> : ""}
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    {mode == "create" ? "Create" : ""}
                    {mode == "edit" ? "Edit" : ""}
                  </BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Room Information</CardTitle>
              </CardHeader>
              <CardBody>
                {errorMsg.length > 0 ? (
                  <div
                    style={{
                      backgroundColor: "#FFC0A4",
                      border: "1px solid #ef8157",
                      color: "#66615b",
                      paddingTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <ul>
                      {errorMsg.map((d, index) => (
                        <li key={index}>{d}</li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  ""
                )}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col>
                      <label>Number</label>
                      <FormGroup
                        className={
                          states["number"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter Room Number"
                          type="text"
                          name="number"
                          onChange={handleInputChange}
                          value={values ? values.number : ""}
                        />
                        <label className="error">{states["number"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <label>MAC Address</label>
                      <FormGroup
                        className={
                          states["macAddress"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <Input
                          placeholder="Enter MAC Address"
                          type="text"
                          name="macAddress"
                          onChange={handleInputChange}
                          value={values ? values.macAddress : ""}
                        />
                        <label className="error">{states["macAddress"]}</label>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup
                        className={
                          states["profile"].length !== 0 ? "has-danger" : ""
                        }
                      >
                        <SelectComponent
                          label="Profile"
                          fieldName={"Profile"}
                          array={profiles}
                          stateValue={states["profile"]}
                          onChange={(option) => {
                            handleProfileChange(option);
                          }}
                          selectedOption={selectedProfile}
                        />

                        <label className="error">{states["profile"]}</label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button className="btn-round" color="info" type="submit">
                    Submit
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default RoomEdit;
